import { api, publicApi } from './client';

export const authAPI = {
  login: (username, password) => publicApi.post('/auth/login/', { username, password }),
  register: (username, password, inviteCode) =>
    publicApi.post('/auth/register/', { username, password, invite_code: inviteCode }),
  requestPasswordReset: (usernameOrEmail) =>
    publicApi.post('/auth/password-reset/', { username: usernameOrEmail }),
  confirmPasswordReset: (uid, token, newPassword) =>
    publicApi.post('/auth/password-reset/confirm/', { uid, token, new_password: newPassword }),
  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
  },
  me: () => api.get('/athletes/me/'),
};